/**
 * Edit Tracking Reducers for AccountSlice
 * 
 * Handles tracking of edited fields and save/discard operations.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { AccountSliceState } from '../state';

/**
 * Mark a field as edited
 */
export const markFieldAsEdited: CaseReducer<
  AccountSliceState,
  PayloadAction<string>
> = (state, action) => {
  const fieldName = action.payload;
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

/**
 * Clear all edited field markers
 */
export const clearEditedFields: CaseReducer<AccountSliceState> = (state) => {
  state.editedFields = [];
  state.isEdited = false;
};

/**
 * Mark account as saved (update backup and clear edit state)
 */
export const markAsSaved: CaseReducer<AccountSliceState> = (state) => {
  if (state.currentAccount) {
    state.accountBackup = state.currentAccount;
  }
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Discard all changes and restore from backup
 */
export const discardChanges: CaseReducer<AccountSliceState> = (state) => {
  if (state.accountBackup) {
    state.currentAccount = state.accountBackup;
  }
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};
